import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export function PageBanner({ title, crumb }: { title: string; crumb: string }) {
  return (
    <section className="grain relative isolate overflow-hidden border-b border-gold/30" data-testid="page-banner">
      <img src="/images/memphis.jpg" alt="" className="absolute inset-0 -z-20 h-full w-full object-cover" />
      <div className="absolute inset-0 -z-10 bg-ink/85" />
      <div className="mx-auto max-w-7xl px-5 py-16 md:px-10 md:py-20">
        <h1 className="rise font-display text-4xl text-gold sm:text-5xl lg:text-6xl">{title}</h1>
        <nav aria-label="Breadcrumb" className="rise mt-5 flex items-center gap-2 text-[15px] text-mist/80" style={{ animationDelay: "80ms" }}>
          <Link to="/" className="inline-flex min-h-[48px] items-center hover:text-gold">Home</Link>
          <ChevronRight size={16} className="text-gold" />
          <span className="text-gold">{crumb}</span>
        </nav>
      </div>
    </section>
  );
}
